import { render, staticRenderFns } from "./InactiveSVG.vue?vue&type=template&id=453d4b26&scoped=true&"
import script from "./InactiveSVG.vue?vue&type=script&lang=js&"
export * from "./InactiveSVG.vue?vue&type=script&lang=js&"
import style0 from "./InactiveSVG.vue?vue&type=style&index=0&id=453d4b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d4b26",
  null
  
)

export default component.exports